module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightpage",
    attrs: {
      "id": "d7e6"
    }
  }, [_c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("Copyright ©2004, Joanne Kimes. All rights reserved."), _c('br'), _vm._v("This book, or parts thereof, may not be reproduced in any form "), _c('br'), _vm._v("without permission from the publisher; exceptions are made "), _c('br'), _vm._v("for brief excerpts used in published reviews.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("Published by"), _c('br'), _vm._v("Adams Media, an imprint of Simon & Schuster, Inc. "), _c('br'), _vm._v("57 Littlefield Street, Avon MA 02322 U.S.A. "), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.adamsmedia.com",
      "target": "_blank"
    }
  }, [_c('i', [_vm._v("www.adamsmedia.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("ISBN 10:1-58062-934-2"), _c('br'), _vm._v("ISBN 13: 978-1-58062-934-8 (paperback)"), _c('br'), _vm._v("ISBN 13: 978-1-44050-195-1 (EPUB)")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("Printed in the United States of America.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("J I H G")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_c('b', [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _c('br'), _vm._v("Kimes, Joanne."), _c('br'), _vm._v("Pregnancy sucks / Joanne Kimes with Sanford A. Tisherman."), _c('br'), _vm._v("p. cm."), _c('br'), _vm._v("ISBN 1-58062-934-2"), _c('br'), _vm._v("ISBN 13: 978-1-44050-195-1 (EPUB)"), _c('br'), _vm._v("1. Pregnancy — Popular works. 2. Childbirth — Popular works. [DNLM: 1. Pregnancy — Popular Works. 2. Delivery, Obstetric — Popular Works. 3. Puerperium — Popular Works. WQ 150 K49p 2003] I. Tisherman, Sanford A. II. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext"
  }, [_vm._v("RG525.K499 2003"), _c('br'), _vm._v("618.2 — dc21"), _c('br'), _vm._v("2003004459")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "d7e74"
    }
  }, [_vm._v("This publication is designed to provide accurate and authoritative information with regard to the subject matter covered. It is sold with the understanding that the publisher is not engaged in rendering legal, accounting, or other professional advice. If legal advice or other expert assistance is required, the services of a competent professional person should be sought."), _c('br'), _vm._v("       — From a "), _c('i', [_vm._v("Declaration of Principles")]), _vm._v(" jointly adopted by a Committee of the American Bar Association and a Committee of Publishers and Associations")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "d7e81"
    }
  }, [_vm._v("This publication is designed to provide accurate and authoritative information with regard to the subject matter covered. It is sold with the understanding that the publisher is not engaged in rendering professional medical advice. If assistance is required, the services of a competent professional person should be sought.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    attrs: {
      "id": "d7e85"
    }
  }, [_vm._v("Cover photo by Andreas Pollok/Getty Images.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrighttext",
    attrs: {
      "id": "d7e87"
    }
  }, [_c('i', [_vm._v("This book is available at quantity discounts for bulk purchases."), _c('br'), _vm._v("For information, call 1-800-289-0963.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bcafae2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kime_9781440501951_epub_part1.vue
// module id = 66
// module chunks = 0